import { graphql } from '@/generated/gql';

export const NEGOTIATION_QUOTE_DETAILS_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationQuoteDetailsUpdate($negotiationCaseId: UUID!, $data: TsrctQuoteInput!) {
    tesseract {
      negotiationCase(id: $negotiationCaseId) {
        quote {
          create(data: $data) {
            id
            supplierReference
            totalValue
            paymentTerms {
              daysToPayment
              discount
            }
            lineItems {
              id
              position
              quantity
              description
              pricePerUnit
              unitId
              deliveryLocationId
              organizationId
              status
            }
          }
        }
      }
    }
  }
`);
